import { render, staticRenderFns } from "./Tendency.vue?vue&type=template&id=52008771&scoped=true&"
import script from "./Tendency.vue?vue&type=script&lang=js&"
export * from "./Tendency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52008771",
  null
  
)

export default component.exports